/*
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 全局组件统一管理
 * @Date: 2021-09-07 14:11:22
 * @LastEditTime: 2022-01-20 20:42:52
 */
import Header from "./Header"
import AddApp from "./AddApp"
import DashAddApp from "./DashAddApp.vue"
import Footer from "./Footer"
import KeepRanking from "./KeepRanking"
import Rank from "./Rank"
import SelectCountry from "./SelectCountry"
import SelectDay from "./SelectDay"
import SelectStore from "./SelectStore"
import Sign from "./Sign"
import AppItem from "./AppItem"
import Table from "./Table"
import PayTypes from "./PayTypes"
import ContactUs from "./ContactUs"
import SelectTabDay from "./SelectTabDay"
import SelectStoreType from "./SelectStoreType"
import DeliveryType from "./DeliveryType"
import SelectStars from "./SelectStars"
import SelectApp from "./SelectApp"
import Loading from "./Loading"
import CommonLoading from "./CommonLoading"
import NullData from "./NullData"
import IconSvg from './IconSvg'
import ReviewLanguageSelect from './ReviewLanguageSelect'
import LottieAnim from './LottieAnim'
import ContactType from './ContactType'
const obj = {
  AddApp,
  PayTypes, //选择支付渠道
  ContactUs, //联系我们
  Footer,
  Header,
  DashAddApp,
  KeepRanking,
  Rank, // Rank排名曲线图
  SelectCountry,// 选择国家
  SelectDay, //选择/新增日期 
  SelectStore,// 选择app类型-tab切跳转版
  Sign,// 标签信息
  Table,// table表格
  AppItem,
  SelectTabDay, //选择/新增日期 tab版本
  SelectStoreType,//选择app类型-弹出层版
  DeliveryType , //交付类型
  SelectStars,//选择评分
  SelectApp,//点击单元格获取App信息
  Loading,// loading
  NullData,
  IconSvg,
  ReviewLanguageSelect ,//国家
  CommonLoading,//通用loading
  LottieAnim,
  ContactType
}

export default function(vue){
  Object.keys(obj).forEach((key)=>{
    vue.component(key,obj[key])
  })

}